export const NOT_AVAILABLE = 'N/A';

// CaptionType values as transformed by the saga (parseEnumType converts numeric
// enum indices to their string keys from transactionCaptionTypes).
export const FIELD_CAPTION_TYPE = {
  ORDER_TOTAL: 'OrderTotal',
  PRICE_PER_UNIT: 'PricePerUnit',
  REFERENCE_NUMBER: 'ReferenceNumber',
  SUBMITTER: 'Submitter',
  SUMMARY: 'Summary',
  CREDIT_CARD: 'CreditCardLastFourDigits',
  SHIPPING_FEE: 'ShippingFee',
  INSURANCE_FEE: 'ShippingInsuranceFee',
  PRE_AUTH_AMOUNT: 'CreditCardAuthorizedAmount',
};

export const getTransactionField = (fields, captionType) =>
  (fields ?? []).find((f) => f.CaptionType === captionType) ?? null;

// Canonical SFH order status sequence shown on the History screen.
export const SFH_STATUS_STEPS = [
  'requestSubmitted',
  'inTransit',
  'received',
  'verified',
  'sold',
];

const STATUS_TYPE_TO_STEP = {
  PendingExecution: 0,
  InTransit: 1,
  Executed: 2,
  Settled: 3,
  Completed: 4,
};

export const getSfhCurrentStepIndex = (transaction) =>
  STATUS_TYPE_TO_STEP[transaction?.StatusType] ?? 0;

// Expected BE response shape for transaction.StatusSteps once the backend
// exposes a proper status-history feed:
//
// StatusSteps: [
//   { key: 'requestSubmitted', status: 'completed', dateTime: '2026-06-12T09:41:00Z', cancellable: true  },
//   { key: 'inTransit',        status: 'pending',   dateTime: null,                   cancellable: false },
//   { key: 'received',         status: 'pending',   dateTime: null,                   cancellable: false },
//   { key: 'verified',         status: 'pending',   dateTime: null,                   cancellable: false },
//   { key: 'sold',             status: 'pending',   dateTime: null,                   cancellable: false },
// ]
//
// status:     'completed' | 'pending' | 'cancelled'
// dateTime:   ISO 8601 UTC string when the step completed, null while pending
// cancellable: true only on the requestSubmitted step while the order can still be cancelled

export function buildTimelineSteps(transaction) {
  if (transaction?.StatusSteps) {
    return transaction.StatusSteps;
  }
  // Fallback until BE ships StatusSteps: derive from the scalar StatusType.
  const currentIndex = getSfhCurrentStepIndex(transaction);
  return SFH_STATUS_STEPS.map((key, idx) => ({
    key,
    status: idx <= currentIndex ? 'completed' : 'pending',
    dateTime: idx <= currentIndex ? transaction?.DateTime ?? null : null,
    cancellable: idx === 0 && currentIndex === 0,
  }));
}
